module.exports = __webpack_public_path__ + "static/media/trophy.82365fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/trophy.svg
// module id = 302
// module chunks = 0